// Pure formatters and constants used by checkout-renewal disclosures.
// No React deps so it can be imported from React bundles AND legacy default/* scripts.
import moment from 'moment';
import { numberToCurrency } from 'shared/helpers/numbers';

export const TERMS_OF_SERVICE_URL = "https://www.loomly.com/terms";

export const renewalDateCopy = (date) => moment(date).format("MM-DD-YYYY");

export const subscriptionPriceCopy = (amount, cycle) => {
  if (cycle === 'yearly') {
    return `${numberToCurrency(amount)} per year, equivalent to ${numberToCurrency(amount / 12)} per month`;
  }

  return `${numberToCurrency(amount)} per month`;
};

export const introductoryPriceCopy = (amount, cycle, endsOn) => {
  const durationCopy = moment(endsOn).fromNow(true);

  if (cycle === 'yearly') {
    return `${numberToCurrency(amount)} for ${durationCopy}, equivalent to ${numberToCurrency(amount / 12)} per month`;
  }

  return `${numberToCurrency(amount)} per month for ${durationCopy}`;
};
